export default __webpack_public_path__ + "static/media/value-sustainability.0d99a89e.svg";